import { render, staticRenderFns } from "./ProjectLayout.vue?vue&type=template&id=68be1848&scoped=true"
import script from "./ProjectLayout.vue?vue&type=script&lang=js"
export * from "./ProjectLayout.vue?vue&type=script&lang=js"
import style0 from "./ProjectLayout.vue?vue&type=style&index=0&id=68be1848&prod&lang=scss"
import style1 from "./ProjectLayout.vue?vue&type=style&index=1&id=68be1848&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68be1848",
  null
  
)

export default component.exports